module.exports = __webpack_public_path__ + "img/IMG-20210111-WA0010.a27fb6e5.jpg";